import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";
import UserProfile from "../components/common/UserProfile";
import AppScreen from "../components/common/AppScreen";


const header = [
  {
    label: 'Logo',
    field: 'logo',
    sort: 'asc',
    width: 40,
    type:"IMAGE",
    editType:"file"
  },
  {
    label: 'App Title',
    field: 'appTitle',
    sort: 'asc',
    width: 150,
    editType:"text"
  },
  {
    label: 'App Sub Title',
    field: 'subTitle',
    sort: 'asc',
    width: 150,
    editType:"text"
  },
  {
    label: 'Background Color',
    field: 'backgroundColor',
    sort: 'asc',
    width: 200,
    editType:"color",
  }
];

const baseName = "AppInfo";
const firebaseDb = firebases.database().ref().child('appInfo');
let context = null;
class AppInfo extends React.Component{

constructor(props){


super();
this.state = {item:{}};
context = this;
}

componentDidMount(){

this.fetchItemFromDb(this.props.match.params.id);
this.setState({id:this.props.match.params.id});
}


fetchItemFromDb = (id)=>{

  firebaseDb.on('value', snap => {
    
   
    snap.forEach(shot => {


        context.setState({[shot.key]:shot.val()});
        

    });

    console.log(this.state);


  });


}


render(){
  const {item,id} = this.state;
  return(
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Splash Screen" subtitle="App Settings " md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <Row>
     
      <Col lg="8">
      <FormItem title="App Info" id={id} model={header} dbType="object" item={this.state} type="UPDATE" action="Update APP" firebaseDb={firebaseDb} firebaseStorage={files} baseName={baseName}/>
      </Col>
      <Col lg="4">
        <AppScreen info={this.state}/>
      </Col>
    </Row>
  </Container>
);
}
}
export default AppInfo;
